// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 745 ? "posthog" : chunkId) + "." + {"236":"1922955b","266":"004d671b","584":"e1e9b57e","595":"d13197fe","602":"a5f9589f","693":"32e5dae9","745":"ab7d0a47"}[chunkId] + ".chunk.js";
};